import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule, NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

@Component({
  selector: 'app-log-list-filter-popup',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzModalModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzDatePickerModule,
    NzButtonModule,
    NzIconModule,
    I18nPipe,
    TestIdDirective
  ],
  template: `
    <form nz-form [testId]="'log-filter-form'">
      <!-- 筛选字段选择器 -->
      <nz-form-item [testId]="'log-filter-field-selector-item'">
        <nz-form-label [testId]="'log-filter-field-selector-label'">{{ 'log.select-filter-fields' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-field-selector-control'">
          <nz-select
            [(ngModel)]="selectedFilterKeys"
            nzMode="multiple"
            [nzAllowClear]="true"
            nzPlaceHolder="{{ 'common.select' | i18n }}"
            name="selectedFilterKeys"
            id="selectedFilterKeys"
            [testId]="'log-filter-field-selector'"
          >
            <nz-option
              *ngFor="let field of allFilterKeys"
              [nzValue]="field.key"
              [nzLabel]="field.label"
              [testId]="'log-filter-field-option-' + field.key"
            />
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item [testId]="'log-filter-keywords-item'">
        <nz-form-label nzFor="keywords" [testId]="'log-filter-keywords-label'">{{ 'log.keywords' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-keywords-control'">
          <nz-input-group [nzSuffix]="clearKeywordsTpl" [testId]="'log-filter-keywords-input-group'">
            <input
              nz-input
              id="keywords"
              placeholder="{{ 'log.keywords' | i18n }}"
              [(ngModel)]="filterParams.keywords"
              name="keywords"
              [testId]="'log-filter-keywords-input'"
            />
            <ng-template #clearKeywordsTpl>
              <span
                *ngIf="filterParams.keywords"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('keywords')"
                [testId]="'log-filter-keywords-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <!-- 新增帐号姓名筛选 -->
      <nz-form-item [testId]="'log-filter-account-name-item'">
        <nz-form-label nzFor="name" [testId]="'log-filter-account-name-label'">{{ 'log.account-name' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-account-name-control'">
          <nz-input-group [nzSuffix]="clearNameTpl" [testId]="'log-filter-account-name-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.account-name' | i18n }}"
              [(ngModel)]="filterParams.name"
              name="name"
              id="name"
              [testId]="'log-filter-account-name-input'"
            />
            <ng-template #clearNameTpl>
              <span
                *ngIf="filterParams.name"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('name')"
                [testId]="'log-filter-account-name-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="selectedFilterKeys.includes('tokenId')" [testId]="'log-filter-token-id-item'">
        <nz-form-label nzFor="tokenId" [testId]="'log-filter-token-id-label'">Token ID</nz-form-label>
        <nz-form-control [testId]="'log-filter-token-id-control'">
          <nz-input-group [nzSuffix]="clearTokenIdTpl" [testId]="'log-filter-token-id-input-group'">
            <input
              nz-input
              placeholder="Token ID"
              [(ngModel)]="filterParams.tokenId"
              name="tokenId"
              id="tokenId"
              [testId]="'log-filter-token-id-input'"
            />
            <ng-template #clearTokenIdTpl>
              <span
                *ngIf="filterParams.tokenId"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('tokenId')"
                [testId]="'log-filter-token-id-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="selectedFilterKeys.includes('clientTraceId')" [testId]="'log-filter-client-trace-id-item'">
        <nz-form-label nzFor="clientTraceId" [testId]="'log-filter-client-trace-id-label'">{{
          'log.client-trace-id' | i18n
        }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-client-trace-id-control'">
          <nz-input-group [nzSuffix]="clearClientTraceIdTpl" [testId]="'log-filter-client-trace-id-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.client-trace-id' | i18n }}"
              [(ngModel)]="filterParams.clientTraceId"
              name="clientTraceId"
              id="clientTraceId"
              [testId]="'log-filter-client-trace-id-input'"
            />
            <ng-template #clearClientTraceIdTpl>
              <span
                *ngIf="filterParams.clientTraceId"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('clientTraceId')"
                [testId]="'log-filter-client-trace-id-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="selectedFilterKeys.includes('requestPath')" [testId]="'log-filter-request-path-item'">
        <nz-form-label nzFor="requestPath" [testId]="'log-filter-request-path-label'">{{ 'log.request-path' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-request-path-control'">
          <nz-input-group [nzSuffix]="clearRequestPathTpl" [testId]="'log-filter-request-path-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.request-path' | i18n }}"
              [(ngModel)]="filterParams.requestPath"
              name="requestPath"
              id="requestPath"
              [testId]="'log-filter-request-path-input'"
            />
            <ng-template #clearRequestPathTpl>
              <span
                *ngIf="filterParams.requestPath"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('requestPath')"
                [testId]="'log-filter-request-path-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="selectedFilterKeys.includes('channel')" [testId]="'log-filter-channel-item'">
        <nz-form-label nzFor="channel" [testId]="'log-filter-channel-label'">{{ 'log.channel-source' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-channel-control'">
          <nz-select
            [(ngModel)]="filterParams.channel"
            nzPlaceHolder="{{ 'log.select-channel' | i18n }}"
            name="channel"
            id="channel"
            [nzAllowClear]="true"
            [testId]="'log-filter-channel-select'"
          >
            <nz-option *ngFor="let option of channelOptions" [nzValue]="option" [nzLabel]="option" [testId]="'log-filter-channel-option'" />
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="selectedFilterKeys.includes('osType')" [testId]="'log-filter-os-type-item'">
        <nz-form-label nzFor="osType" [testId]="'log-filter-os-type-label'">{{ 'log.os-type' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-os-type-control'">
          <nz-select
            [(ngModel)]="filterParams.osType"
            nzPlaceHolder="{{ 'log.select-os-type' | i18n }}"
            name="osType"
            id="osType"
            [nzAllowClear]="true"
            [testId]="'log-filter-os-type-select'"
          >
            <nz-option *ngFor="let option of osTypeOptions" [nzValue]="option" [nzLabel]="option" [testId]="'log-filter-os-type-option'" />
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="selectedFilterKeys.includes('requestTimeRange')" [testId]="'log-filter-time-range-item'">
        <nz-form-label nzFor="requestTimeRange" [testId]="'log-filter-time-range-label'">{{
          'log.request-time-range' | i18n
        }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-time-range-control'">
          <nz-range-picker
            nzShowTime
            [nzAllowClear]="true"
            [(ngModel)]="filterParams.requestTimeRange"
            name="requestTimeRange"
            id="requestTimeRange"
            [testId]="'log-filter-time-range-picker'"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="selectedFilterKeys.includes('hasError')" [testId]="'log-filter-status-item'">
        <nz-form-label nzFor="hasError" [testId]="'log-filter-status-label'">{{ 'log.status' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-status-control'">
          <nz-select
            [(ngModel)]="filterParams.hasError"
            nzPlaceHolder="{{ 'log.select-status' | i18n }}"
            name="hasError"
            id="hasError"
            [nzAllowClear]="true"
            [testId]="'log-filter-status-select'"
          >
            <nz-option
              *ngFor="let option of statusOptions"
              [nzValue]="option.value"
              [nzLabel]="option.label"
              [testId]="'log-filter-status-option'"
            />
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- 新增耗时范围筛选 -->
      <nz-form-item *ngIf="selectedFilterKeys.includes('timeCost')" [testId]="'log-filter-time-cost-item'">
        <nz-form-label nzFor="timeCostRange" [testId]="'log-filter-time-cost-label'">{{ 'log.time-cost' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-time-cost-control'">
          <nz-input-group [nzSuffix]="clearTimeCostTpl" [testId]="'log-filter-time-cost-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.time-cost' | i18n }}"
              [(ngModel)]="filterParams.timeCost"
              name="timeCost"
              id="timeCost"
              [testId]="'log-filter-time-cost-input'"
            />
            <ng-template #clearTimeCostTpl>
              <span
                *ngIf="filterParams.timeCost"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('timeCost')"
                [testId]="'log-filter-time-cost-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <!-- 新增设备ID筛选 -->
      <nz-form-item *ngIf="selectedFilterKeys.includes('uniqueId')" [testId]="'log-filter-device-id-item'">
        <nz-form-label nzFor="uniqueId" [testId]="'log-filter-device-id-label'">{{ 'log.device-id' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-device-id-control'">
          <nz-input-group [nzSuffix]="clearUniqueIdTpl" [testId]="'log-filter-device-id-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.device-id' | i18n }}"
              [(ngModel)]="filterParams.uniqueId"
              name="uniqueId"
              id="uniqueId"
              [testId]="'log-filter-device-id-input'"
            />
            <ng-template #clearUniqueIdTpl>
              <span
                *ngIf="filterParams.uniqueId"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('uniqueId')"
                [testId]="'log-filter-device-id-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <!-- TraceID筛选 -->
      <nz-form-item *ngIf="selectedFilterKeys.includes('traceId')" [testId]="'log-filter-trace-id-item'">
        <nz-form-label nzFor="traceId" [testId]="'log-filter-trace-id-label'">{{ 'log.trace-id' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-trace-id-control'">
          <nz-input-group [nzSuffix]="clearTraceIdTpl" [testId]="'log-filter-trace-id-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.trace-id' | i18n }}"
              [(ngModel)]="filterParams.traceId"
              name="traceId"
              id="traceId"
              [testId]="'log-filter-trace-id-input'"
            />
            <ng-template #clearTraceIdTpl>
              <span
                *ngIf="filterParams.traceId"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('traceId')"
                [testId]="'log-filter-trace-id-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <!-- 设备名称筛选 -->
      <nz-form-item *ngIf="selectedFilterKeys.includes('deviceName')" [testId]="'log-filter-device-name-item'">
        <nz-form-label nzFor="deviceName" [testId]="'log-filter-device-name-label'">{{ 'log.device-name' | i18n }}</nz-form-label>
        <nz-form-control [testId]="'log-filter-device-name-control'">
          <nz-input-group [nzSuffix]="clearDeviceNameTpl" [testId]="'log-filter-device-name-input-group'">
            <input
              nz-input
              placeholder="{{ 'log.device-name' | i18n }}"
              [(ngModel)]="filterParams.deviceName"
              name="deviceName"
              id="deviceName"
              [testId]="'log-filter-device-name-input'"
            />
            <ng-template #clearDeviceNameTpl>
              <span
                *ngIf="filterParams.deviceName"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="clearField('deviceName')"
                [testId]="'log-filter-device-name-clear-icon'"
              ></span>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </form>
  `,
  styles: `
    :host {
      display: block;
      padding: 24px;
    }

    nz-form-item {
      margin-bottom: 16px;
    }

    nz-form-label {
      width: 120px;
      text-align: left;
      margin-right: 12px;
    }

    nz-form-control {
      flex: 1;
    }

    nz-input-group,
    input,
    nz-select,
    nz-date-picker,
    nz-range-picker {
      width: 100%;
    }

    .ant-input-clear-icon {
      color: rgba(0, 0, 0, 0.25);
      cursor: pointer;
      font-size: 12px;
      transition: color 0.3s;

      &:hover {
        color: rgba(0, 0, 0, 0.45);
      }
    }
  `
})
export class LogListFilterPopupComponent implements OnInit {
  filterParams: any = {};
  osTypeOptions: string[] = [];
  statusOptions: any[] = [];
  channelOptions: string[] = [];
  allFilterKeys: Array<{ key: string; label: string }> = [];
  selectedFilterKeys: string[] = [];

  private readonly modalRef = inject(NzModalRef);
  nzModalData: any = inject(NZ_MODAL_DATA); // 注入 NZ_MODAL_DATA

  ngOnInit(): void {
    this.filterParams = this.nzModalData.filterParams || {};
    this.osTypeOptions = this.nzModalData.osTypeOptions || [];
    this.statusOptions = this.nzModalData.statusOptions || [];
    this.channelOptions = this.nzModalData.channelOptions || [];
    this.allFilterKeys = this.nzModalData.allFilterKeys || [];
    this.selectedFilterKeys = this.nzModalData.selectedFilterKeys || [];
  }

  clearField(field: string): void {
    if (this.filterParams) {
      this.filterParams[field] = '';
    }
  }

  handleOk(): void {
    this.modalRef.close({ filterParams: this.filterParams, selectedFilterKeys: this.selectedFilterKeys });
  }

  handleCancel(): void {
    this.modalRef.close();
  }
}
